import { render, staticRenderFns } from "./company-booking.vue?vue&type=template&id=313e4ba9&"
import script from "./company-booking.vue?vue&type=script&lang=js&"
export * from "./company-booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports